import React from "react";
import treatmentcardimage1 from "../../../assets/images/our_team_full_banner.webp";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import { IoCall } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { FaPhoneAlt } from "react-icons/fa";
import { DecryptFunction } from "../../../utils/cryptoFunction";
import { LogEvent } from "../../../utils/firebase";
import bannerTamil from "../../../assets/images/yourFarm_mission_tamil.webp";
import bannerMarati from "../../../assets/images/yourFarm_mission_marati.webp";
import bannerTamilN from "../../../assets/images/homeBannerwithblue.webp";


const TreatmentCard = () => {
  const { t, i18n } = useTranslation();

  const getOurTeamImageSource = () => {
    if (i18n.language === "tm") {

      return bannerTamilN;

    } else if (i18n.language === "mr") {

      return bannerTamilN; // Tamil Image Source
    } else {

      return bannerTamilN; // Tamil Image Source
    }
  };

  return (
    <>


      <Container
        fluid
        className="our_team_background"

        style={{
          backgroundColor: "white",
          height: "46vw",
          position: "relative",
        }}


      >


        <Container
          className="our_team_banner_overlay"
          style={{
            position: "absolute",
            top: "24%",
            left: "50%",
            transform: "translate(-50%, -20%)",
            width: "86%",
            maxWidth: "1600px",
            padding: 0,
          }}
        >
          <img
            style={{

              width: "100%",
              height: "auto",
              maxHeight: "650px",
              minHeight: "220px",
              objectFit: "cover",
              borderRadius: "24px",
            }}
            src={getOurTeamImageSource()}
            alt=""
          />


        </Container>
      </Container >
    </>
  );
};

export default TreatmentCard;
